var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__a",
    x1: 48,
    x2: 48,
    y1: 29.833,
    y2: 35.539,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__a)",
    d: "M53.91 30A5.99 5.99 0 0 1 48 35a5.99 5.99 0 0 1-5.91-5h11.82z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__b",
    x1: 21,
    x2: 21,
    y1: 22.833,
    y2: 37.504,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__b)",
    d: "M28 23v10c-2.21 0-4 1.79-4 4H14c0-7.73 6.27-14 14-14z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__c",
    x1: 32,
    x2: 32,
    y1: 2,
    y2: 61.397,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__c)",
    d: "M58 29c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2H47.483A24.003 24.003 0 0 0 28 13C14.767 13 4 23.767 4 37s10.767 24 24 24a23.986 23.986 0 0 0 17.878-8H58c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2 0-3.962-2.321-7.382-5.67-9 3.349-1.618 5.67-5.038 5.67-9zm0-2H38v-2h20v2zM36 49v2a2 2 0 0 0 .876 1.653A17.81 17.81 0 0 1 28 55c-9.587 0-17.426-7.541-17.949-17h13.05A5.009 5.009 0 0 0 28 42c2.757 0 5-2.243 5-5a5.01 5.01 0 0 0-4-4.899V19.05A17.732 17.732 0 0 1 39.287 23H38c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2 0 3.962 2.322 7.382 5.67 9-3.348 1.618-5.67 5.038-5.67 9-1.103 0-2 .897-2 2zm-8-15c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm-1-1.899A5.016 5.016 0 0 0 23.101 36h-13.05c.505-9.126 7.823-16.444 16.949-16.949v13.05zM28 59C15.869 59 6 49.131 6 37s9.869-22 22-22a22.003 22.003 0 0 1 16.958 8h-2.701C38.512 19.19 33.35 17 28 17 16.972 17 8 25.972 8 37s8.972 20 20 20c4.372 0 8.504-1.389 11.983-4h3.113A21.984 21.984 0 0 1 28 59zm30-8H38v-2h20v2zm-2-4H40c0-4.072 3.06-7.436 7-7.931V41h2v-1.931c3.94.495 7 3.859 7 7.931zm-7-10.069V35h-2v1.931c-3.94-.495-7-3.859-7-7.931h16c0 4.072-3.06 7.436-7 7.931z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__d",
    x1: 45,
    x2: 45,
    y1: 2,
    y2: 61.397,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__d)",
    d: "M49.949 17.536 41.465 9.05l-1.414 1.414 8.484 8.486z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__e",
    x1: 11,
    x2: 11,
    y1: 2,
    y2: 61.397,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__e)",
    d: "M15.949 10.464 14.535 9.05l-8.484 8.486 1.414 1.414z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__f",
    x1: 28,
    x2: 28,
    y1: 2,
    y2: 61.397,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#clock_svg__f)",
    d: "M28 11c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
  })));
};
export default SvgClock;